export const getBasePermissions = (module) => {
    try {
        let menus = {};
        try {
            const rawMenus = localStorage.getItem('menus');
            if (rawMenus) menus = JSON.parse(rawMenus) || {};
        } catch(e) {}

        const user = JSON.parse(localStorage.getItem('authUser') || '{}');
        const role = (user?.role || user?.user_role || '').toLowerCase();
        const isAdmin = ['admin', 'superadmin', 'owner', 'master'].includes(role) || user?.username === 'owner';

        const modulesArray = typeof module === 'string' ? module.split(',').map((m) => m.trim()) : [];
        const menuData = {};
        modulesArray.forEach((m) => {
            if (menus && menus[m]) {
                menuData[m] = menus[m];
            }
        });

        return {
            role: user?.role || user?.user_role || '',
            isAdmin: isAdmin,
            menu: menuData,
        };
    } catch(err) {
        return {
            role: '',
            isAdmin: false,
            menu: {}
        };
    }
}